import { render, staticRenderFns } from "./Gkid.vue?vue&type=template&id=36eef216&"
import script from "./Gkid.vue?vue&type=script&lang=js&"
export * from "./Gkid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports